if (!customElements.get('blog-filter')) {
  class BlogFilter extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (evt) => {
        const btn = evt.target.closest('[data-nav-value]');
        if (!btn) return;

        this.querySelectorAll('[data-nav-value]').forEach((el) => {
          el.classList.toggle('is-active', el === btn);
        });

        this.applyFilter(btn.dataset.navValue);
      });
    }

    /**
     * Shows only the grid cards whose data-nav-values list includes the
     * given value (an article can carry up to 3, so it can show under
     * multiple nav items). An empty value shows everything.
     * @param {string} value - Selected nav value, or '' for "All".
     */
    applyFilter(value) {
      document.querySelectorAll('[data-nav-values]').forEach((item) => {
        if (!value) {
          item.hidden = false;
          return;
        }
        const values = (item.dataset.navValues || '').split('||').filter(Boolean);
        item.hidden = !values.includes(value);
      });
    }
  }

  customElements.define('blog-filter', BlogFilter);
}
